import React from 'react'
const SectionTwo: React.FC<any> = () => {
    return (
        <>
            <div className="table-checkout">
                <div className="container-fluid">
                    <h1>Why Choose KwikCheckout’s One-Click
                        Checkout Over Others?</h1>
                    <div style={{overflowX: 'auto'}}>
                        <table>
                            <tbody>
                                <tr>
                                    <th>Value Proposition</th>
                                    <th className='tblwidth'>Simpl</th>
                                    <th className='tblwidth'>Other Players</th>
                                    <th className='tblbgcolor'>KwikCheckout by GoKwik</th>
                                </tr>
                                <tr>
                                    <td>Deepest Network Of 100 Million+ D2C Shoppers</td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37} /></td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37} /></td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/right.png' width={37} /></td>
                                </tr>
                                <tr>
                                    <td>Highest Address Pre-fill Accuracy & Fraud Pin code Detection</td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37} /></td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37} /></td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/right.png' width={37} /></td>
                                </tr>
                                <tr>
                                    <td>Highest & Most Customised eCommerce Discounts Offered</td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37} /></td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37} /></td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/right.png' width={37} /></td>
                                </tr>
                                <tr>
                                    <td>Best-in-class RTO Intelligence With Risk-based COD Interventions</td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37} /></td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37} /></td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/right.png' width={37} /></td>
                                </tr>
                                <tr>
                                    <td>Industry's First Partial COD Payment</td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37} /></td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/wrong.png' width={37} /></td>
                                    <td className='tblalign'><img src='/assets/images/one-click-kwikcheckout/right.png' width={37} /></td>
                                </tr>
                                <tr>
                                    <td>Payment Assurance With ZERO Payment Failures</td>
                                    <td className='tblalign'>80-85%</td>
                                    <td className='tblalign'>80-85%</td>
                                    <td className='tblalign'>Up to 100%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}
export default SectionTwo